module.exports = __webpack_public_path__ + "img/kota_bdg.7764836d.png";